import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Store} from '@ngxs/store';
import {Subscription} from 'rxjs';
import {MustMatch} from '../../../validators/mustMatch.validator';
import {ValidateUserNameNotTaken} from '../../../validators/usernameNotTaken.validator';
import {UserService} from '../../../services/user/user.service';
import {CreateUser} from '../../../../state/actions/appState.users.actions';

@Component({
  selector: 'app-account-settings-modal',
  templateUrl: './create-user-modal.component.html',
  styleUrls: ['./create-user-modal.component.scss']
})
export class CreateUserModalComponent implements OnInit, OnDestroy {
  userForm: FormGroup;

  private subs: Subscription[] = [];

  constructor(
    private activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private store: Store,
    private cd: ChangeDetectorRef,
    private userService: UserService
  ) {
  }

  ngOnInit(): void {
    this.userForm = this.fb.group({
      userName: new FormControl(
        '', [Validators.required], [ValidateUserNameNotTaken.validate(this.userService, [])]),
      firstName: new FormControl(
        '', [Validators.required]),
      lastName: new FormControl(
        '', [Validators.required]),
      password: new FormControl(
        '', [Validators.required, Validators.minLength(5)]),
      repeat: new FormControl(
        '', [Validators.required]),
      admin: new FormControl(
        false, [Validators.required])
    }, {
      validator: MustMatch('password', 'repeat')
    });
    this.subs.push(
      this.userForm.valueChanges.subscribe(() => {
        this.cd.detectChanges();
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

  closeModal() {
    this.activeModal.close();
  }

  submitUser() {
    this.store.dispatch(new CreateUser(this.userForm.getRawValue())).toPromise().then(() => this.closeModal());
  }
}
